import { IconProps } from '.';

export const OrderedListIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg className={className} width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 17h2v.5H3v1h1v.5H2v1h3v-4H2zm1-9h1V4H2v1h1zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2zm5-6v2h14V5zm0 14h14v-2H7zm0-6h14v-2H7z'
        fill={color}
      />
    </svg>
  );
};
